// extracted by css-extract-rspack-plugin
export default {"cls1":"PaperContainer-cls1_Xof","cls2":"PaperContainer-cls2_JhW PaperContainer-cls1_Xof"};